import React from "react";
// import { handleApiredirectionAndTheme } from "../App";
import RedirectionHandler from "../utils/RedirectionHandler";
const EDPNewExcelEntry = ({ newEntry }) => {
  // const plateform = handleApiredirectionAndTheme(
  //   window.location.host
  // ).plateform;

  // const plateform = RedirectionHandler[window.location.host]?.plateform;
  return (
    <div className="p-4 bg-white rounded-lg shadow-sm">
      <h2 className="text-lg font-semibold mb-2">EDP Status Report</h2>
      {newEntry.length > 0 ? (
        <table className="min-w-full text-sm text-left text-gray-500">
          <thead className="bg-gray-100 text-gray-700">
            <tr>
              <th className="py-2 px-4">VIN Number</th>

              <th className="py-2 px-4">Model</th>
              <th className="py-2 px-4">Color</th>
              <th className="py-2 px-4">Variant</th>
              <th className="py-2 px-4">Fuel Type</th>
              <th className="py-2 px-4">YOM</th>
              <th className="py-2 px-4">Status</th>
            </tr>
          </thead>
          <tbody>
            {newEntry.map((entry, index) => (
              <tr key={index} className="border-b">
                <td className="py-2 px-4">{entry.win_num}</td>

                <td className="py-2 px-4">{entry.model_name}</td>
                <td className="py-2 px-4">{entry.colour}</td>
                <td className="py-2 px-4">{entry.variant}</td>
                <td className="py-2 px-4">{entry.fueltype}</td>
                <td className="py-2 px-4">{entry.yom}</td>
                <td className="py-2 px-4">{entry.GDMSExcelStatus}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className="text-xs text-gray-500">No entries available</p>
      )}
    </div>
  );
};

export default EDPNewExcelEntry;
